import {DataFetcher} from '@aboutyou/data-fetcher';
import React, {FC} from 'react';
import {CategoryTilesLoading} from './CategoryTilesLoading';
import {CategoryTilesView, CategoryTilesViewProps} from './CategoryTilesView';
import {useGetCategoryTiles} from './useGetCategoryTiles';

export const CategoryTiles: FC<CategoryTilesViewProps> = props => (
  <DataFetcher
    request={useGetCategoryTiles()}
    Error={null}
    Loading={CategoryTilesLoading}
    View={CategoryTilesView}
    viewProps={props}
  />
);
